module.exports = __webpack_public_path__ + "media/images/lb/070-8cddc3cbf7ee3085576f7032c7ebddfa.svg";